import bundleFeature from '../../utils/bundleFeature'

import sagas from './sagas'
import actions from './actions'
import reducer from './reducer'
import { WebinarAudienceMobileSidebarComponent } from './components/WebinarAudienceSidebarComponent/WebinarAudienceMobileSidebarComponent'
import { WebinarAudienceSidebarComponent } from './components/WebinarAudienceSidebarComponent/WebinarAudienceSidebarComponent'

const WebinarAudienceSidebarFeature = bundleFeature({
  Component: WebinarAudienceSidebarComponent,
  actions,
  sagas,
  reducer,
})

const WebinarAudienceMobileSidebarFeature = bundleFeature({
  Component: WebinarAudienceMobileSidebarComponent,
  actions,
  sagas,
  reducer,
})

export { WebinarAudienceSidebarFeature, WebinarAudienceMobileSidebarFeature }
